export default __webpack_public_path__ + "assets/bronze.4aea17f71e8f31002fddccc4a36b8078.svg";